import { ClientConfigDto } from "@repo/api/client-config";
import { AmplifilesClient } from "./api-client";

export class ClientConfigApi {
  static async getClientConfig(): Promise<ClientConfigDto | null> {
    const response = await AmplifilesClient.instance.get("/client-config");
    return ClientConfigDto.nullable().parse(response.data);
  }
}
